import {BrowserRouter} from "react-router-dom";
import SiteHeader from "./Components/SiteHeader/SiteHeader";
import LoginPage from './Components/LoginPage/LoginPage';
import MobilePage from './Components/MobilePage/MobilePage';
import { isMobile } from 'react-device-detect';
import axios from "axios";

if (process.env.NODE_ENV === 'development') {
  console.log('Running in development mode via react-scripts start');
  axios.defaults.baseURL = 'http://127.0.0.1:8000';
} 



export default function App() {
  const creds = localStorage.getItem("token");
  const isLoggedIn = !(creds === null || creds.length <= 0)
  if (isMobile)
    return (<MobilePage/>)

  let content; 
  if (isLoggedIn)
    content = <SiteHeader/>
  else 
    content = <LoginPage />

  return (
    <BrowserRouter>
      {content}
    </BrowserRouter>
  );
}

